{
  "title": "Groups",
  "subtitle": "Mirrored from the customer's directory. Set field fills for blank attributes, a priority when someone is in more than one group, and an optional signature for members who match no operator rule.",
  "searchPlaceholder": "Search groups",
  "colGroup": "Group",
  "colMembers": "Members",
  "colPriority": "Priority",
  "colOverrides": "Overrides",
  "colSignature": "Signature",
  "emptySearch": "No groups match that search.",
  "emptyNone": "No groups have synced yet. Connect a directory on Overview or Onboarding.",
  "priority": "Priority",
  "signatureTemplate": "Group signature",
  "noSignature": "None (fall through)",
  "overrides": "Attribute overrides",
  "save": "Save group",
  "saved": "Group saved.",
  "saveError": "Could not save that group.",
  "none": "None",
  "count": "{{count}}",
  "groupFallback": "Group",
  "fieldsCount": "{{count}} field",
  "fieldsCount_other": "{{count}} fields",
  "signatureSet": "Set",
  "overridePriorityTitle": "Override priority",
  "overridePriorityHint": "When a person is in several groups that fill the same blank field, the higher priority wins.",
  "savePriority": "Save priority",
  "prioritySaved": "Priority saved.",
  "groupSignatureTitle": "Group signature",
  "groupSignatureHint": "Used when no operator rule matches and the person has no customised signature. Loses to Rules; beats the tenant default.",
  "publishTemplateFirst": "Publish a template before assigning a group signature.",
  "newMessages": "New messages",
  "replies": "Replies",
  "sameAsNew": "Same as new",
  "saveSignature": "Save signature",
  "signatureSaved": "Group signature saved.",
  "signatureCleared": "Group signature cleared.",
  "fieldFillsTitle": "Field fills",
  "fieldFillsSaved": "Field fills saved.",
  "membersTitle": "Members",
  "membersHint": "Membership is synced from the directory, including nested groups.",
  "noMembers": "No members synced yet.",
  "viaNestedGroup": "via nested group",
  "couldNotSave": "Could not save."
}
